// extracted by mini-css-extract-plugin
var _1 = "SetUsername__more--CnPG4";
var _2 = "SetUsername__possible--uSlpy";
var _3 = "SetUsername__selected--KDR7I";
var _4 = "SetUsername__userNameContainer--PNUTD OfficeGeneral__centeredColumn--asLhi";
var _5 = "SetUsername__username--q1HqY OfficeGeneral__textSizeV--Kk8Z9 CoreGeneral__textSizeV--CFQxz";
export { _1 as "more", _2 as "possible", _3 as "selected", _4 as "userNameContainer", _5 as "username" }
